import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToArrBis'
})
export class NumberToArrPipeBis implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    value = (value !== undefined) ? value : 0;
    value = parseInt(value);
    return new Array(value);
  }

}
